export function slotsMagic(node: Node) {
  if (node.nodeType !== Node.ELEMENT_NODE) return null

  const el = node as HTMLElement
  const slots: Record<string, boolean> = {}
  const slottedEl = el.closest('[x-slotted]')
  if (slottedEl) {
    const slottedAttr = slottedEl.getAttribute('x-slotted')!
    const slottedNames = JSON.parse(slottedAttr)
    for (const name of slottedNames) {
      slots[name] = true
    }
    // @ts-ignore
    el._x_slots = slots
    return slots
  }

  let targetEl: HTMLElement | null = el
  // @ts-ignore
  while (targetEl && !targetEl._x_slots) {
    targetEl = targetEl.parentElement
  }

  // @ts-ignore
  return targetEl?._x_slots
}
